import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'mutationobserver-shim'
import './directives'
import './registerServiceWorker'
import './plugins'

import Vue from 'vue'
import AppComponent from './App.vue'
import router from './router'
import store from './store'
import i18n from './config/i18n'

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(AppComponent)
})

window.addEventListener('load', ({ currentTarget }) => {
  currentTarget.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/5.4.149/pdf.worker.min.mjs'
})

Vue.config.productionTip = false

app.$mount('#app')
